
import React from "react";
import { Card } from "primereact/card";
import { QuestionResponse } from "./models";
import { RadioButton } from "primereact/radiobutton";

interface TableColumn {
	Sequence: number;
	Header: string;
}
interface TableCell {
	Sequence: number;
	Value: string;
}
interface TableRow {
	Sequence: number;
	Label: string;
	Cells: TableCell[];
}
interface TableData {
	QuestionText: string;
	Columns: TableColumn[];
	Rows: TableRow[];
}

export default function CommonTableComponent({ response,isDynamic,isCheckbox }: { response: QuestionResponse[],isDynamic?:boolean,isCheckbox?:boolean }) {
	// Find the first non-empty fieldValue and parse it

  const tableData: TableData | null = React.useMemo(() => {
    const valid = response.find(r => r.fieldValue && r.fieldValue !== "null" && r.fieldValue !== "[]");
    if (!valid) return null;
    try {
      const parsed = JSON.parse(valid.fieldValue);
      // If parsed is an empty array, treat as no data
      if (Array.isArray(parsed) && parsed.length === 0) return null;
      return parsed;
    } catch {
      return null;
    }
  }, [response]);

  if (!tableData) return <Card><div>No data available</div></Card>;

	// Sort columns, rows, and cells by Sequence
	const sortedColumns = [...tableData.Columns].sort((a, b) => a.Sequence - b.Sequence);
	const sortedRows = [...tableData.Rows].sort((a, b) => a.Sequence - b.Sequence);

	  return (
    <div
      style={{
        background: "#dee2e6",
        padding: "12px 10px 20px 10px",
        borderRadius: "4px",
        margin: "8px 0"
      }}
    >
      <div
        style={{
          background: "#fff",
          border: "1px solid #e0e3e7",
          borderRadius: "3px",
          boxShadow: "0 1px 2px rgba(60,72,88,0.04)",
          padding: "0",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
          <thead>
            <tr>
              { !isDynamic && <th
                style={{
                  textAlign: "left",
                  fontWeight: 600,
                  padding: "14px 16px",
                  borderBottom: "1px solid #e0e3e7",
                  background: "#fff",
                  border: "0.2px solid #ccc"
                }}
              >
                
              </th>}
              {sortedColumns.map(col => (
                <th
                  key={col.Sequence}
                  style={{
                    textAlign: "left",
                    fontWeight: 600,
                    padding: "14px 16px",
                    borderBottom: "1px solid #e0e3e7",
                    background: "#fff",
                    border: "0.2px solid #ccc"
                  }}
                >
                  {col.Header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedRows.map((row, idx) => {
              const sortedCells = [...row.Cells].sort((a, b) => a.Sequence - b.Sequence);
              return (
                <tr key={row.Sequence}
                  style={{
                    borderBottom: idx === sortedRows.length - 1 ? "none" : "1px solid #e0e3e7",
                    background: "#fff"
                  }}
                >
                  { !isDynamic &&<td style={{ padding: "14px 16px", border: "0.2px solid #ccc", color: "#222", background: "#fff" }}>
                    {row.Label}
                  </td>}
                  {sortedCells.map(cell => (
                    <td
                      key={cell.Sequence}
                      style={{
                        padding: "14px 16px",
                        color: "#222",
                        background: "#fff",
                        border: "0.2px solid #ccc"
                      }}
                    >
                      {!isCheckbox?cell.Value:<RadioButton inputId={`rb${cell.Sequence}`} name="response" value={cell.Value} checked={!!cell.Value} />}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
